export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export const STATUS_COMPLETE = 'Complete';
export const STATUS_CANCELLED = 'Cancelled';
export const STATUS_ONHOLD = 'On Hold';
export const STATUS_ALL = 'All';

export const PRODUCT_TYPE_RESIDENTIAL = 'Residential';
export const PRODUCT_TYPE_COMMERCIAL = 'Commercial';
export const PRODUCT_TYPE_ALL = 'All';

export const TABLE_HEADER_ORDER_REF_TITLE = 'Order Reference';
export const TABLE_HEADER_ORDER_REF_KEY = 'orderReference';
export const TABLE_HEADER_PRODUCT_TITLE = 'Product';
export const TABLE_HEADER_PRODUCT_KEY = 'product';
export const TABLE_HEADER_DATE_ORDERED_TITLE = 'Date Ordered';
export const TABLE_HEADER_STATUS_TITLE = 'Status';
export const TABLE_HEADER_STATUS_KEY = 'status';
export const TABLE_HEADER_STATUS_DATE_TITLE = 'Status Date';
export const TABLE_HEADER_COMPLETEDBY_TITLE = 'Completed By';
export const TABLE_HEADER_COMPLETEDBY_KEY = 'completedBy';
export const TABLE_HEADER_QCBY_TITLE = "QC'ed By";
export const TABLE_HEADER_QCBY_KEY = 'qualityControlledBy';
export const TABLE_HEADER_ONHOLD_REASON_TITLE = 'On Hold Reason';
export const TABLE_HEADER_ONHOLD_REASON_KEY = 'onHoldReason';
export const TABLE_HEADER_ONHOLD_REASON_DATE_TITLE = 'Date Placed On Hold';

export const SORT_ORDER_ASC = 'Ascending';
export const SORT_ORDER_DESC = 'Descending';
export const SORT_ORDER_ASC_SHORT = 'asc';
export const SORT_ORDER_DESC_SHORT = 'desc';

export const ORDERS_EXPORT_FILENAME = 'orders';
export const ORDERS_HISTORY_EXPORT_FILENAME = 'orders-history';
export const ORDERS_ONHOLD_EXPORT_FILENAME = 'orders-onhold';

export const CREATED_ON_VAL = 'CreatedOn';

export const FORM_MIN_WIDTH = 150;
